import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`SDK Configuration Errors`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Error ID`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Recovery Suggestion`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`missing-configuration`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Returned when the internal SDK configuration is not present.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Check if you have an active internet connection.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`invalid-client-token`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Returned when the provided client token does not have a valid JWT format.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Ensure that the client token fetched from your backend is a valid client token (i.e. not null, not blank, is valid JWT and it comes from Primer)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`expired-client-token`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Returned when the provided client token has expired.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Avoid storing client tokens locally. Fetch a new client token to provide on when starting Primer.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`missing-sdk-dependency`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Returned when an SDK dependency is missing for a payment method type.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Follow the integration guide and include missing dependency.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      